/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Screen_Open_Body_MapInputs */

const en_us2_onboarding_screen_open_body_map = /** @type {(inputs: Onboarding_Screen_Open_Body_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show where it hurts`)
};

const pt_br2_onboarding_screen_open_body_map = /** @type {(inputs: Onboarding_Screen_Open_Body_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar onde dói`)
};

const es_419_onboarding_screen_open_body_map = /** @type {(inputs: Onboarding_Screen_Open_Body_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar dónde me duele`)
};

const pt_pt2_onboarding_screen_open_body_map = /** @type {(inputs: Onboarding_Screen_Open_Body_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar onde dói`)
};

const fr_fr2_onboarding_screen_open_body_map = /** @type {(inputs: Onboarding_Screen_Open_Body_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indiquer où j'ai mal`)
};

const de_de2_onboarding_screen_open_body_map = /** @type {(inputs: Onboarding_Screen_Open_Body_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeigen, wo es wehtut`)
};

const it_it2_onboarding_screen_open_body_map = /** @type {(inputs: Onboarding_Screen_Open_Body_MapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra dove fa male`)
};

/**
* | output |
* | --- |
* | "Show where it hurts" |
*
* @param {Onboarding_Screen_Open_Body_MapInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_screen_open_body_map = /** @type {((inputs?: Onboarding_Screen_Open_Body_MapInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Screen_Open_Body_MapInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_screen_open_body_map(inputs)
	if (locale === "es-419") return es_419_onboarding_screen_open_body_map(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_screen_open_body_map(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_screen_open_body_map(inputs)
	if (locale === "de-DE") return de_de2_onboarding_screen_open_body_map(inputs)
	if (locale === "it-IT") return it_it2_onboarding_screen_open_body_map(inputs)
	return en_us2_onboarding_screen_open_body_map(inputs)
});
export { onboarding_screen_open_body_map as "onboarding.screen_open.body-map" }